import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

import { useAuth } from "contexts/AuthContext";
import UserService from 'services/User.service';

const UserSettingContext = createContext();
const orgID = process.env.REACT_APP_ORGANIZATIONNAME;
// const checkMockup = process.env.REACT_APP_IS_MOCKUP;

export const UserSettingProvider = ({ children }) => {
  const { token } = useAuth();
  const [userState, setUserState] = useState(null);

  const getUser = async () => {
    let tokenSetting = jwtDecode(token);
    const response = await UserService.getUserSetting(orgID, tokenSetting.name)
    setUserState(response.data)
  };

  useEffect(() => {
    if(token){
      getUser()
    }
  }, [token]);

  const setUserContext = () => {
    // setUserState(user);
  };

  return (
    <UserSettingContext.Provider value={{ userState, setUserContext }}>
      {children}
    </UserSettingContext.Provider>
  );
};

export const useUserContext = () => {
  const context = useContext(UserSettingContext);
  if (!context) {
    throw new Error('useUserContext 必須在 UserSettingProvider 中使用');
  }
  return context;
};
